module.exports = __webpack_public_path__ + "static/media/dish18.9ecd20b6.jpg";